type IRecursiveMethod = (array: any, field: string) => any[]


//рекурсивный метод получающий всех детей в виде плоского списка
//передается массив и поле по которому проводится рекурсия
const getFlatListElements: IRecursiveMethod = (array, field): any[] => {
  return array.flatMap((element: any) => {
    if (element[field])
      if (element[field]?.length)
        return getFlatListElements(element[field], field)
      else
        return element
    else
      return element
  })
}
const recursiveEditorM = (element: any, dynamicDataArray: any, type: "FIELDS" | "UNITS") => {
  let {data} = element
  let copyDynamicDataArray = Object.assign([], dynamicDataArray)
  if (data) {
    return {
      ...element,
      data: data.map((item: any) => recursiveEditorM(item, copyDynamicDataArray, type))
    }
  } else {
    if(element.hasOwnProperty("dynamicData")){
      element.dynamicData = {
        ...element.dynamicData,
        rawData: false
      }
    }else{
      element.dynamicData = {
        rawData: false
      }
    }
    
    let dynamic = dynamicDataArray.filter((i: any) => i.id == element.glid)
    
    dynamic.forEach((dynamicItem:any)=>{
      switch (type) {
        case "FIELDS":
          element.dynamicData = {
            ...element.dynamicData,
            ...dynamicItem.values
          }
          break;
        case "UNITS":
          let {values, id} = dynamicItem
          
          let position: any = element.dynamicData.position || []
          let track: any = element.dynamicData.track || []
          let unitState: any = values.unitState || ""
          let azimuth: any = values.azimuth || 0
      
          if (values.hasOwnProperty("rt_position")) {
            position = values.rt_position
            track.unshift([...position, values.rt_time])
          }
      
          if (values.hasOwnProperty("position")) {
            position = values.position
          }
      
          if (values.hasOwnProperty("track")) {
            track = [...track ,...values.track]
          }
      
          if (!track.length && position.length) {
            track = [position]
          }
      
          track = track.filter(([,,trackTime]: any)=>{
            let date1 = new Date().getMinutes()
            let date2 = new Date(trackTime).getMinutes()
            return (date1 - date2) < 30
          })
          track.sort((a:any, b:any)=>b[2] - a[2])
      
          element.dynamicData = {
            ...element.dynamicData,
            position,
            track,
            unitState,
            azimuth
          }
      }
  
      element.dynamicData.rawData = true
    })
    
    return element
  }
}






const getPrepareDataRecursive = (element: any, type: any) =>{
  const listFilters: any = []
  
  const recursive = (data: any) =>{
    
    switch (type) {
      case "FIELDS":
        break
      case "UNITS":
        break
    }
    
    if(data?.data){
      return {
        ...data,
        data: data.data.map(recursive)
      }
    }
    
    return data
  }
  
  const objectElements: any = recursive(element)
  
  return {
    filters: listFilters,
    elements: objectElements
  }
}

export {getFlatListElements, recursiveEditorM, getPrepareDataRecursive}